export const adminDashboardQueryKeys = {
  all: ['SummaryBoard'] as const,
  list: () => [...adminDashboardQueryKeys.all] as const,
  detail: (dashboardId: string) => ['SummaryBoardDetail', { dashboardId }] as const,
}
